import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
  colorClassName1?: string;
  colorClassName2?: string;
};
const PriorityLow = ({ size = "sm", colorClassName1 = "", colorClassName2 = "", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.4959 3.97247C10.4959 3.69633 10.7198 3.47247 10.9959 3.47247H11.9959C12.2721 3.47247 12.4959 3.69633 12.4959 3.97247V12.0275C12.4959 12.3037 12.2721 12.5275 11.9959 12.5275H10.9959C10.7198 12.5275 10.4959 12.3037 10.4959 12.0275V3.97247Z"
        fill="currentColor"
        className={colorClassName1}
      />
      <path
        d="M7.49997 5.47247C7.22383 5.47247 6.99997 5.69633 6.99997 5.97247V12.0275C6.99997 12.3037 7.22383 12.5275 7.49997 12.5275H8.49997C8.77611 12.5275 8.99997 12.3037 8.99997 12.0275V5.97247C8.99997 5.69633 8.77611 5.47247 8.49997 5.47247H7.49997Z"
        fill="currentColor"
        className={colorClassName1}
      />
      <path
        d="M4.00403 8.12866C3.72789 8.12866 3.50403 8.35252 3.50403 8.62866V12.0275C3.50403 12.3037 3.72789 12.5275 4.00403 12.5275H5.00403C5.28017 12.5275 5.50403 12.3037 5.50403 12.0275V8.62866C5.50403 8.35252 5.28017 8.12866 5.00403 8.12866H4.00403Z"
        fill="currentColor"
        className={colorClassName2}
      />
    </svg>
  );
};
export default PriorityLow;
